<template>
	<div
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div v-if="isHeaderVisible" class="panel_header">
				<h2>{{ block.block_title }}</h2>
				<div v-if="block.description" v-html="block.description" class="description"></div>
			</div>
			<div class="items-container"
				:class="[block.appearance? block.appearance : '']"
			>
				<div class="row">
					<div
						v-for="(item, index) in block.items"
						v-if="block.items"
						:key="index"
						class="col-12 mt-4"
						:class="[
							block.columns ? 'col-lg-' + 12/block.columns : 'col-lg-4'
						]"
					>
						<div
							class="item"
							:class="[
								item.appearance ? item.appearance : ''
							]"
						>
							<div v-if="item.title" class="title">
								{{ item.title }}
							</div>
							<div
								v-if="item.description"
								class="description"
								v-html="blockContent(item.description)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'DraftWhyWe5',
	mixins: [panel],
	props: {
		block: { type: Object, required: true },
		loyaltyProfile: { type: Object, default: null },
	},
	data() {
		return {
			loyaltyPercent: null,
		};
	},
	computed: {
		bonusPercent() {
			return `${this.loyaltyProfile.level.max_payment_percent}%`;
		},
	},
	methods: {
		blockContent(innerHtml) {
			if (this.loyaltyProfile) {
				return innerHtml.replace('{XX%}', this.bonusPercent);
			}

			return innerHtml;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/dev/draft-whywe-5';
</style>
